/**
 * Функции которые устанавливают цвет для гридов
 * */

function setColorsOnProducersGrid(grid: kendo.ui.Grid) {
    const smsToDriverColumnIndex = window.getColumnIndexByField(grid, 'SmsToDriver');
    const smsToClientColumnIndex = window.getColumnIndexByField(grid, 'SmsToClient');
    const rows = grid.tbody.children();

    for (let i = 0; i < rows.length; i++) {
        const row = $(rows[i]);
        const dataItem = grid.dataItem(row);
        if (!dataItem)
            return;

        if (smsToDriverColumnIndex !== -1) {
            const smsToDriverStatus = dataItem.get('SmsToDriver');
            const statusCell = row.children().eq(smsToDriverColumnIndex);
            statusCell.css('color', window.getSmsStatusColor(smsToDriverStatus));
        }
        if (smsToClientColumnIndex !== -1) {
            const smsToClientStatus = dataItem.get('SmsToClient');
            const statusCell = row.children().eq(smsToClientColumnIndex);
            statusCell.css('color', window.getSmsStatusColor(smsToClientStatus));
        }
    }
}

function setGreyColorOnDefaultCellInGrid(grid: kendo.ui.Grid, values: string[]) {
    const rows = grid.tbody.children();
    for (let i = 0; i < rows.length; i++) {
        const row = $(rows[i]);
        const dataItem = grid.dataItem(row);
        if (!dataItem)
            return;

        setColorInCell(row, values);
    }

    const footerRow = $('.k-grid-footer-wrap > table > tbody').children();

    for (let i = 0; i < footerRow.length; i++) {
        const fRow = $(footerRow[i]);

        setColorInCell(fRow, values);
    }
}

function setColorInCell(row: JQuery<HTMLElement>, values: string[]) {
    let child: JQuery;
    for (let j = 0; j < row.children().length; j++) {
        child = row.children().eq(j);

        const content = window.removeHtml(child[0].textContent!).trim();
        for (let index in values) {
            if (content === values[index]) {
                child.css('background-color', `#bbbec1`);
                break;
            }
        }
    }
}

function setColorsOnAnswerGrid(grid: kendo.ui.Grid) {
    const statusColumnIndex = window.getColumnIndexByField(grid, 'Status');
    const rows = grid.tbody.children();

    for (let i = 0; i < rows.length; i++) {
        if ($(rows[i]).hasClass('k-group-footer'))
            continue;
        const row = $(rows[i]);
        const dataItem = grid.dataItem(row);

        if (dataItem && statusColumnIndex !== -1) {
            const status = dataItem.get('Status');
            const statusCell = row.children().eq(statusColumnIndex);
            statusCell.css('background-color', window.getAnswerStatusColor(status));
        }
    }
}

function setColorsOnTicketsGrid(grid: kendo.ui.Grid) {
    const ticketProjectsIndex = window.getColumnIndexByField(grid, 'TicketProjects');
    const statusColumnIndex = window.getColumnIndexByField(grid, 'Status');
    const priorityColumnIndex = window.getColumnIndexByField(grid, 'PriorityPriority');
    const psychologicalComplexityColumnIndex = window.getColumnIndexByField(grid, 'PsychologicalComplexityPriority');
    const personalTicketPriorityColumnIndex = window.getColumnIndexByField(grid, 'PersonalTicketPriorityPriority');
    const influenceOnMoneyColumnIndex = window.getColumnIndexByField(grid, 'InfluenceOnMoneyPriority');
    const costPriorityColumnIndex = window.getColumnIndexByField(grid, 'TicketPriorityPriority');
    const dtEndColumnIndex = window.getColumnIndexByField(grid, 'DtEnd');
    const penaltyColumnIndex = window.getColumnIndexByField(grid, 'Penalty');

    const rows = grid.tbody.children();
    for (let i = 0; i < rows.length; i++) {
        if ($(rows[i]).hasClass('k-group-footer')) {
            continue;
        }
        const row = $(rows[i]);
        const dataItem = grid.dataItem(row);
        if (!dataItem) return;

        if (ticketProjectsIndex !== -1) {
            const ticketProjectColors = dataItem.get('TicketProjectColors');
            if (ticketProjectColors) {
                const ticketProjectCell = row.children().eq(ticketProjectsIndex);
                for (let j = 0; j < ticketProjectCell.children('a').length; j++) {
                    ticketProjectCell.children('a').eq(j).css('background-color', `#${ticketProjectColors[j]}`);
                }
            }
        }

        if (statusColumnIndex !== -1) {
            const status = dataItem.get('Status');
            const statusCell = row.children().eq(statusColumnIndex);
            statusCell.css('background-color', window.getTicketStatusColor(status));
        }

        if (priorityColumnIndex !== -1) {
            const priorityColor = dataItem.get('PriorityColorColorValue');
            const priorityCell = row.children().eq(priorityColumnIndex);
            priorityCell.css('background-color', `#${priorityColor}`);
        }

        if (personalTicketPriorityColumnIndex !== -1) {
            const personalTicketPriorityColor = dataItem.get('PersonalTicketPriorityColorColorValue');
            const personalTicketPriorityCell = row.children().eq(personalTicketPriorityColumnIndex);
            personalTicketPriorityCell.css('background-color', `#${personalTicketPriorityColor}`);
        }

        if (psychologicalComplexityColumnIndex !== -1) {
            const complexityColor = dataItem.get('PsychologicalComplexityColorColorValue');
            const complexityCell = row.children().eq(psychologicalComplexityColumnIndex);
            complexityCell.css('background-color', `#${complexityColor}`);
        }

        if (influenceOnMoneyColumnIndex !== -1) {
            const influenceOnMoneyColor = dataItem.get('InfluenceOnMoneyColorColorValue');
            const influenceOnMoneyCell = row.children().eq(influenceOnMoneyColumnIndex);
            influenceOnMoneyCell.css('background-color', `#${influenceOnMoneyColor}`);
        }

        if (costPriorityColumnIndex !== -1) {
            const priorityColor = dataItem.get('TicketPriorityColorColorValue');
            const priorityCell = row.children().eq(costPriorityColumnIndex);
            priorityCell.css('background-color', `#${priorityColor}`);
        }

        if (dtEndColumnIndex !== -1) {
            const dtEnd = dataItem.get('DtEnd');
            const dtEndCell = row.children().eq(dtEndColumnIndex);
            dtEndCell.css('background-color', window.getTicketDeadlineColor(dtEnd));
        }

        if (penaltyColumnIndex !== -1) {
            const penalty = dataItem.get('Penalty');
            const penaltyCell = row.children().eq(penaltyColumnIndex);
            penaltyCell.css('background-color', window.getTicketPenaltyColor(penalty));
        }
    }
}

function setColorsOnReminderGrid(grid: kendo.ui.Grid) {
    const ticketProjectIndex = window.getColumnIndexByField(grid, 'TicketProjectName');
    const rows = grid.tbody.children();

    for (let i = 0; i < rows.length; i++) {
        if ($(rows[i]).hasClass('k-group-footer'))
            continue;
        const row = $(rows[i]);
        const dataItem = grid.dataItem(row);
        if (!dataItem) return;

        if (ticketProjectIndex !== -1) {
            const ticketProjectColor = dataItem.get('TicketProjectColor');
            const ticketProjectCell = row.children().eq(ticketProjectIndex);
            ticketProjectCell.css('background-color', `#${ticketProjectColor}`);
        }
    }
}

function setColorsOnMarkerReportGrid(grid: kendo.ui.Grid) {
    const deviationStartTimeColumnIndex = window.getColumnIndexByField(grid, 'DeviationStartTime');
    const deviationStartBreakTimeColumnIndex = window.getColumnIndexByField(grid, 'DeviationStartBreakTime');
    const deviationEndBreakTimeColumnIndex = window.getColumnIndexByField(grid, 'DeviationEndBreakTime');
    const deviationEndTimeColumnIndex = window.getColumnIndexByField(grid, 'DeviationEndTime');
    const deviationFundWorkingTimeColumnIndex = window.getColumnIndexByField(grid, 'DeviationFundWorkingTime');
    const rows = grid.tbody.children();

    for (let i = 0; i < rows.length; i++) {
        if ($(rows[i]).hasClass('k-group-footer'))
            continue;
        const row = $(rows[i]);
        const dataItem = grid.dataItem(row);
        if (!dataItem) return;

        if (deviationStartTimeColumnIndex !== -1) {
            const deviationStartTime = dataItem.get('DeviationStartTime');
            const time = window.formatTime(deviationStartTime);
            if (window.isValid(time)) {
                const deviationStartTimeCell = row.children().eq(deviationStartTimeColumnIndex);
                deviationStartTimeCell.css('background-color', window.getTimeSpanColor(time));
            }
        }
        if (deviationStartBreakTimeColumnIndex !== -1) {
            const deviationStartBreakTime = dataItem.get('DeviationStartBreakTime');
            const time = window.formatTime(deviationStartBreakTime);
            if (window.isValid(time)) {
                const deviationStartBreakTimeCell = row.children().eq(deviationStartBreakTimeColumnIndex);
                deviationStartBreakTimeCell.css('background-color', window.getTimeSpanColor(time));
            }
        }
        if (deviationEndBreakTimeColumnIndex !== -1) {
            const deviationEndBreakTime = dataItem.get('DeviationEndBreakTime');
            const time = window.formatTime(deviationEndBreakTime);
            if (window.isValid(time)) {
                const deviationEndBreakTimeCell = row.children().eq(deviationEndBreakTimeColumnIndex);
                deviationEndBreakTimeCell.css('background-color', window.getTimeSpanColor(time));
            }
        }
        if (deviationEndTimeColumnIndex !== -1) {
            const deviationEndTime = dataItem.get('DeviationEndTime');
            const time = window.formatTime(deviationEndTime);
            if (window.isValid(time)) {
                const deviationEndTimeCell = row.children().eq(deviationEndTimeColumnIndex);
                deviationEndTimeCell.css('background-color', window.getTimeSpanColor(time));
            }
        }
        if (deviationFundWorkingTimeColumnIndex !== -1) {
            const deviationFundWorkingTime = dataItem.get('DeviationFundWorkingTime');
            const time = window.formatTime(deviationFundWorkingTime);
            if (window.isValid(time)) {
                const deviationFundWorkingTimeCell = row.children().eq(deviationFundWorkingTimeColumnIndex);
                deviationFundWorkingTimeCell.css('background-color', window.getTimeSpanColor(time));
            }
        }
    }
}

function setColorsOnGridByField(grid: kendo.ui.Grid, field: string, emptyValues: string[]) {
    const fieldId = window.getColumnIndexByField(grid, field);
    const viewRows = $('tbody [role="row"]:not(.k-grouping-row)');
    const dataRows = grid.dataItems();

    viewRows.each((_, row) => {
        const rowElem = $(row);
        const cells = rowElem.children();
        const dataRow = dataRows.find((i: { uid: string }) => i.uid === rowElem.attr('data-uid'));
        const currentCell = cells[fieldId];

        if (!dataRow || !currentCell) return;

        const fieldValue = dataRow[`${field}`];

        if (fieldValue !== '' && emptyValues && !emptyValues.includes(fieldValue)) {
            currentCell.style.backgroundColor = (fieldValue === 'Да' || fieldValue === true) ? '#6bff7b' : 'red';
        }
        else {
            currentCell.style.backgroundColor = '';
        }
    });
}

function setColorsTdYesNo() {
    $('.k-grid').each((_, element) => {
        const grid = $(element).data('kendoGrid');

        if (grid) {
            colorCells(grid);
            return;
        }

        const treeList = $(element).data('kendoTreeList');
        colorCells(treeList);
    });
}

function colorCells(control?: kendo.ui.Grid | kendo.ui.TreeList) {
    if (control) {
        const setColorHandler = () => queueMicrotask(() => window.setColorCellsWithValueYesNoUnknown(control));

        control.bind('dataBound', setColorHandler);
        control.bind('edit', () => {
            $('.k-grid-cancel').on('click', setColorHandler);
            $('.k-window-action').on('click', setColorHandler);
        });
    }
}

function setColorCellsWithValueYesNoUnknown(instance: kendo.ui.Grid | kendo.ui.TreeList) {
    const cellsForColoring = instance.element.find('td:not([data-disable-default-coloring-yes-no-unknown])');
    cellsForColoring.each((_, td) => {
        const value = td.textContent?.trim();
        value === 'Да' && (td.style.backgroundColor = 'rgb(144, 238, 144)');
        value === 'Нет' && (td.style.backgroundColor = 'rgb(255, 192, 203)');
        value === 'Неизвестно' && (td.style.backgroundColor = 'rgb(255, 255, 0)');
    });
}

window.setColorCellsWithValueYesNoUnknown = setColorCellsWithValueYesNoUnknown;
window.colorCells = colorCells;
window.setColorInCell = setColorInCell;
window.setColorsOnAnswerGrid = setColorsOnAnswerGrid;
window.setColorsOnGridByField = setColorsOnGridByField;
window.setColorsOnMarkerReportGrid = setColorsOnMarkerReportGrid;
window.setColorsOnProducersGrid = setColorsOnProducersGrid;
window.setColorsOnReminderGrid = setColorsOnReminderGrid;
window.setColorsTdYesNo = setColorsTdYesNo;
window.setGreyColorOnDefaultCellInGrid = setGreyColorOnDefaultCellInGrid;
window.setColorsOnTicketsGrid = setColorsOnTicketsGrid;